(() => {
  const init = (root) => {
    if (!root || root.dataset.dnReady === "true") return;
    root.dataset.dnReady = "true";

    const form = root.querySelector("form.dn-buy");
    const quantityInput = root.querySelector("[data-dn-quantity]");
    const mainImage = root.querySelector("[data-dn-main-image]");
    const currentIndex = root.querySelector("[data-dn-current-index]");
    const mobileBuybar = root.querySelector("[data-dn-mobile-buybar]");
    const headerCta = root.querySelector("[data-dn-header-cta]");
    const hero = root.querySelector(".dn-hero");
    const price = Number(root.dataset.priceCents || 0) / 100;
    const currency = root.dataset.currency || "EUR";
    const formatter = new Intl.NumberFormat(document.documentElement.lang || "fr-FR", { style: "currency", currency });
    window.dataLayer = window.dataLayer || [];

    const updateEstimatedDelivery = () => {
      const liveProof = root.querySelector("[data-dn-live-proof]");
      const deliveryNode = liveProof?.querySelector("[data-dn-estimated-delivery]");
      if (!liveProof || !deliveryNode) return;
      const businessDays = Math.max(1, Number.parseInt(liveProof.dataset.deliveryDays || "2", 10) || 2);
      const deliveryDate = new Date();
      let added = 0;
      while (added < businessDays) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
        const day = deliveryDate.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }
      const isEnglish = (liveProof.dataset.locale || document.documentElement.lang || "fr").toLowerCase().startsWith("en");
      const formattedDate = new Intl.DateTimeFormat(isEnglish ? "en-GB" : "fr-FR", {
        weekday: "short",
        day: "numeric",
        month: "long",
      }).format(deliveryDate);
      deliveryNode.textContent = isEnglish
        ? `Estimated delivery from ${formattedDate} in mainland France`
        : `Livraison estimée dès le ${formattedDate} en France métropolitaine`;
    };

    const initCountdown = () => {
      const countdown = root.querySelector("[data-dn-countdown]");
      if (!countdown) return;
      const endAt = Date.parse(countdown.dataset.endAt || "");
      if (!Number.isFinite(endAt)) {
        countdown.closest(".dn-flash")?.classList.add("is-expired");
        return;
      }
      const fields = {
        days: countdown.querySelector("[data-dn-days]"),
        hours: countdown.querySelector("[data-dn-hours]"),
        minutes: countdown.querySelector("[data-dn-minutes]"),
        seconds: countdown.querySelector("[data-dn-seconds]"),
      };
      const render = () => {
        const remaining = endAt - Date.now();
        if (remaining <= 0) {
          countdown.closest(".dn-flash")?.classList.add("is-expired");
          window.clearInterval(countdown.dnTimer);
          return;
        }
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60,
        };
        Object.entries(values).forEach(([key, value]) => {
          if (fields[key]) fields[key].textContent = key === "days" ? String(value) : String(value).padStart(2, "0");
        });
      };
      render();
      countdown.dnTimer = window.setInterval(render, 1000);
    };

    const quantity = () => Math.max(1, Math.min(9, Number.parseInt(quantityInput?.value || "1", 10) || 1));
    const item = {
      item_id: root.dataset.sku || root.dataset.productId,
      item_name: root.dataset.productTitle,
      item_brand: root.dataset.vendor,
      currency,
      price,
      quantity: quantity(),
    };

    const track = (event, extra = {}) => {
      window.dataLayer.push({ event, ecommerce: { currency, value: price * quantity(), items: [{ ...item, quantity: quantity() }] }, ...extra });
    };

    const updateTotal = () => {
      if (quantityInput) quantityInput.value = String(quantity());
      root.querySelectorAll("[data-dn-total]").forEach((node) => { node.textContent = formatter.format(price * quantity()); });
    };

    root.querySelector("[data-dn-minus]")?.addEventListener("click", () => {
      quantityInput.value = String(quantity() - 1);
      updateTotal();
    });
    root.querySelector("[data-dn-plus]")?.addEventListener("click", () => {
      quantityInput.value = String(quantity() + 1);
      updateTotal();
    });
    quantityInput?.addEventListener("change", updateTotal);

    root.querySelectorAll("[data-dn-thumb]").forEach((button, index) => {
      button.addEventListener("click", () => {
        if (!mainImage || button.classList.contains("is-active")) return;
        root.querySelectorAll("[data-dn-thumb]").forEach((thumb) => { thumb.classList.remove("is-active"); thumb.removeAttribute("aria-current"); });
        button.classList.add("is-active");
        button.setAttribute("aria-current", "true");
        mainImage.classList.add("is-changing");
        window.setTimeout(() => {
          mainImage.src = button.dataset.src;
          mainImage.alt = button.dataset.alt;
          if (currentIndex) currentIndex.textContent = String(index + 1).padStart(2, "0");
          mainImage.classList.remove("is-changing");
        }, 150);
        track("select_item", { gallery_index: index + 1 });
      });
    });

    const assignExperiment = () => {
      if (root.dataset.experimentEnabled !== "true") return "control";
      const override = new URLSearchParams(window.location.search).get("dn_variant");
      let variant = override === "a" || override === "b" ? override : sessionStorage.getItem("dn-hero-v1");
      if (!variant) {
        variant = Math.random() < .5 ? "a" : "b";
        sessionStorage.setItem("dn-hero-v1", variant);
      }
      root.dataset.experimentVariant = variant;
      const kicker = root.querySelector("[data-dn-kicker]");
      if (kicker) kicker.textContent = variant === "a" ? root.dataset.copyA : root.dataset.copyB;
      if (root.dataset.available === "true") {
        root.querySelectorAll("[data-dn-cta-label]").forEach((node) => { node.textContent = variant === "a" ? root.dataset.ctaA : root.dataset.ctaB; });
      }
      window.dataLayer.push({ event: "experiment_exposure", experiment_id: "dn-hero-v1", experiment_variant: variant });
      return variant;
    };

    const variant = assignExperiment();
    form?.addEventListener("submit", () => track("add_to_cart", { experiment_variant: variant }));

    if (form && mobileBuybar) {
      const observer = new IntersectionObserver(([entry]) => {
        mobileBuybar.classList.toggle("is-visible", !entry.isIntersecting && window.scrollY > 260);
      }, { threshold: .05 });
      observer.observe(form);
    }

    if (hero && headerCta && "IntersectionObserver" in window) {
      const headerObserver = new IntersectionObserver(([entry]) => {
        const heroHasPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        headerCta.classList.toggle("is-visible", heroHasPassed);
      }, { threshold: 0 });
      headerObserver.observe(hero);
    }

    const reveals = root.querySelectorAll("[data-dn-reveal]");
    if ("IntersectionObserver" in window) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      }, { threshold: .12, rootMargin: "0px 0px -7%" });
      reveals.forEach((node) => revealObserver.observe(node));
    } else {
      reveals.forEach((node) => node.classList.add("is-visible"));
    }

    updateTotal();
    updateEstimatedDelivery();
    initCountdown();
    track("view_item", { experiment_variant: variant });
    window.requestAnimationFrame(() => root.classList.add("is-loaded"));
  };

  const boot = () => document.querySelectorAll("[data-dn-section]").forEach(init);
  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", (event) => init(event.target.querySelector("[data-dn-section]")));
  if (document.readyState !== "loading") boot();
})();
